module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#podcast",
      toString: function () {
        return this.url;
      }
    }